import { render, staticRenderFns } from "./show-price.vue?vue&type=template&id=608642c5&scoped=true"
import script from "./show-price.vue?vue&type=script&lang=js"
export * from "./show-price.vue?vue&type=script&lang=js"
import style0 from "./show-price.vue?vue&type=style&index=0&id=608642c5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608642c5",
  null
  
)

export default component.exports